import { render, staticRenderFns } from "./1500_Mobile_Devices_and_Remote_Security.vue?vue&type=template&id=c9c00b20&lang=pug"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports